import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-texteditor',
  templateUrl: './texteditor.component.html',
  styleUrls: ['./texteditor.component.scss']
})
export class TexteditorComponent implements OnInit {

  @Input() public text: string;
  @Input() public element: string;
  @Input() public currency: any = '';
  @Input() public default:string;
  nuevoValor :any;

  @Output() callback: EventEmitter<any> = new EventEmitter;
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      console.log('declaring summernote');
      this.initialize();
      this.removeBarStatus(); // under bar
    }, 500);
  }

  initialize() {
    let _this = this;
    this.input().summernote({
      text: this.default,
      height: 150,                 // set editor height
      minHeight: 150,             // set minimum height of editor
      maxHeight: 150,             // set maximum height of editor
      focus: true,
      disableResizeEditor: true,
      popover: {
        image: [],
        link: [],
        air: []
      },
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol']] 
      ],
      callbacks: {
        onChange: function (contents){
          this.currency = contents;
          _this.emit(this.currency);
        }
      },
    });

    this.input().summernote('code', this.default);
  }

  removeBarStatus() {
    $('.note-statusbar').hide();
  }

  getText() {
    this.input().code();
  }

  setText(text) {
    this.input().summernote('insertText', text);
  }

  input () {
    return $('#' + this.element);
  }
  
  emit(datos) {
    this.callback.emit(datos);
  }

  onNgModelChanges($event) {
    console.log('event ', $event);
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("changes",this.default);
    if (changes.default) {
      this.initialize();
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/components/tools/texteditor/texteditor.component.ts